import { useState, useEffect } from 'react';
import { anotherInstance } from './hookConnect';

const useUserActivities = () => {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);

    const reloadData = () => {
        setRefreshKey(prevKey => prevKey + 1);
    };

    useEffect(() => {
        const fetchUserActivities = async () => {
            setLoading(true);
            setError(null);
            
            try {
                const response = await anotherInstance.get(`userActivity/get`);
                if (response.data && Array.isArray(response.data.data)) {
                    setActivities(response.data.data);
                } else {
                    setActivities([]);
                }
            } catch (error) {
                setError('Ошибка при получении активностей!');
                setActivities([]);
            } finally {
                setLoading(false);
            }
        };
        fetchUserActivities();
    }, [refreshKey]);

    return { activities, loading, error, reloadData };
};

export default useUserActivities;